import { Trophy, Building2, ShieldCheck, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionTag, SectionTitle } from "./Reveal";

const ITEMS = [
  {
    n: "01",
    icon: Trophy,
    badge: "Engajamento",
    title: "Gamificação & ranking da equipe",
    desc: "Pontuação por turno pontual, checklist nota 10 e desperdício zero. XP, streaks e medalhas para engajar a brigada.",
  },
  {
    n: "02",
    icon: Building2,
    badge: "Controle matriz",
    title: "Multi-unidade & franquias",
    desc: "Visão consolidada da matriz: compare conformidade sanitária, absenteísmo e desperdício entre dezenas de filiais.",
  },
  {
    n: "03",
    icon: ShieldCheck,
    badge: "APPCC · ANVISA",
    title: "Conformidade sanitária pronta",
    desc: "Planilhas de controle térmico, PCCs monitorados e relatórios para a vigilância sanitária gerados em um clique.",
  },
];

export default function Ecosystem() {
  return (
    <section data-testid="landing-features-ecosystem" className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <SectionTag>E tudo o que sustenta os três pilares</SectionTag>
            <SectionTitle className="!text-3xl sm:!text-4xl">Uma plataforma só. Da matriz ao fogão.</SectionTitle>
          </div>
          <Link to="/pricing" className="inline-flex items-center gap-1 font-body text-sm font-semibold text-emerald-800 hover:text-emerald-900" data-testid="ecosystem-pricing-link">
            Ver todos os módulos nos planos <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>

        <ul className="mt-10 divide-y divide-stone-200 border-y border-stone-200">
          {ITEMS.map((it, i) => (
            <Reveal key={it.n} delay={i * 0.08}>
              <li className="group grid md:grid-cols-12 gap-4 md:gap-8 items-center py-7 hover:bg-stone-50 transition-colors md:-mx-4 md:px-4 rounded-xl">
                <div className="md:col-span-1 font-display text-4xl font-black text-stone-300 group-hover:text-emerald-700 transition-colors">{it.n}</div>
                <div className="md:col-span-1 h-11 w-11 rounded-xl bg-stone-950 text-emerald-400 flex items-center justify-center">
                  <it.icon className="h-5 w-5" />
                </div>
                <div className="md:col-span-4">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-800 font-body">{it.badge}</span>
                  <h3 className="font-display text-xl font-bold tracking-tight text-stone-950">{it.title}</h3>
                </div>
                <p className="md:col-span-6 font-body text-sm md:text-base text-stone-600 leading-relaxed">{it.desc}</p>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
